import React, { useState } from "react";
import {
  Col,
  Layout,
  Row,
  Image,
  Button,
  Grid,
  Modal,
  Checkbox,
  Input,
  Carousel,
} from "antd";
import img from "../assets/images/logo.png";
import farm from "../assets/images/farm.png";
import AccessCard from "../components/AccessCard";
import Login from "../components/modals/Login";
import { Link, useNavigate } from "react-router-dom";
import RegisterCard from "../components/RegisterCard";
import tractor from "../assets/images/tractor.png";
import farmer from "../assets/images/farmer.png";
import curve from "../assets/svg/curve.svg";
import potato from "../assets/images/potato.png";
import tomato from "../assets/images/tomato.png";
import onion from "../assets/images/onion.png";

const container: React.CSSProperties = {
  height: "calc(100vh + 200px)",
};

const row: React.CSSProperties = {
  height: "50%",
};

const contentStyle: React.CSSProperties = {
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
};

function HomePage() {
  const navigate = useNavigate();
  console.log(process.env);
  return (
    <div className="w-full px-[20px] md:px[40px] md:px-[60px]">
      <section className="w-full flex flex-col-reverse md:flex-row items-center justify-between mt-4">
        <div className="w-full md:w-[43%] flex flex-col items-center">
          <div
            className="w-full md:w-1/2 flex flex-col items-center gap-2"
            style={{
              backgroundImage: `url(${curve})`,
              backgroundSize: "100% 100%",
              backgroundPosition: "center",
              width: 430,
              height: 222,
            }}
          >
            <h1 className="font-bold text-5xl">Organizing</h1>
            <h1 className="font-bold text-5xl text-green-400">Agricultural</h1>
            <div className="pt-2">
              <h1 className="font-bold text-5xl">Value chain</h1>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="pt-4 text-dark-700">
              Shega Fre provide valuable insights into the organizing
              agricultural value chain.designed to empower farmers,
              agribusinesses, and stakeholders with the knowledge and resources
              needed to optimize their operations and maximize their potential.
            </div>
            <div className="cursor-pointer w-full flex flex-row items-center justify-between lg:justify-around my-6">
              <div
                onClick={() => navigate("/subscribe")}
                className="w-[170px] flex flex-row items-center justify-between bg-dark-200 px-3 py-2 rounded-[100px] text-white"
              >
                <div className="flex flex-row items-center justify-center bg-amber-400 w-8 h-8 rounded-full">
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.58593 1.22961L4.02992 1.5996L3.58593 1.22961ZM12.2559 1.22961L11.812 1.5996V1.5996L12.2559 1.22961ZM13.6102 2.85477L14.0542 2.48478V2.48478L13.6102 2.85477ZM2.23163 2.85477L1.78764 2.48478L2.23163 2.85477ZM10.8852 6.16956C10.8852 5.85037 10.6265 5.59162 10.3073 5.59162C9.98809 5.59162 9.72933 5.85037 9.72933 6.16956H10.8852ZM6.11253 6.16956C6.11253 5.85037 5.85378 5.59162 5.53459 5.59162C5.2154 5.59162 4.95665 5.85037 4.95665 6.16956H6.11253ZM14.0542 2.48478L12.6999 0.859625L11.812 1.5996L13.1663 3.22476L14.0542 2.48478ZM11.3393 0.222351H4.50255V1.37824H11.3393V0.222351ZM3.14194 0.859625L1.78764 2.48478L2.67562 3.22476L4.02992 1.5996L3.14194 0.859625ZM14.4647 12.1354V3.61862H13.3088V12.1354H14.4647ZM1.37714 3.61862V12.1354H2.53302V3.61862H1.37714ZM3.74484 14.5031H12.097V13.3472H3.74484V14.5031ZM1.37714 12.1354C1.37714 13.4431 2.43719 14.5031 3.74484 14.5031V13.3472C3.07557 13.3472 2.53302 12.8047 2.53302 12.1354H1.37714ZM13.3088 12.1354C13.3088 12.8047 12.7663 13.3472 12.097 13.3472V14.5031C13.4047 14.5031 14.4647 13.4431 14.4647 12.1354H13.3088ZM4.50255 0.222351C3.97692 0.222351 3.47844 0.455824 3.14194 0.859625L4.02992 1.5996C4.14681 1.45934 4.31996 1.37824 4.50255 1.37824V0.222351ZM12.6999 0.859625C12.3634 0.455824 11.865 0.222351 11.3393 0.222351V1.37824C11.5219 1.37824 11.6951 1.45934 11.812 1.5996L12.6999 0.859625ZM13.1663 3.22476C13.2584 3.33533 13.3088 3.4747 13.3088 3.61862H14.4647C14.4647 3.2043 14.3195 2.80308 14.0542 2.48478L13.1663 3.22476ZM1.78764 2.48478C1.5224 2.80308 1.37714 3.20429 1.37714 3.61862H2.53302C2.53302 3.4747 2.58348 3.33533 2.67562 3.22476L1.78764 2.48478ZM1.95508 4.06287H13.8868V2.90699H1.95508V4.06287ZM9.72933 6.16956C9.72933 7.16831 8.91969 7.97796 7.92093 7.97796V9.13385C9.55806 9.13385 10.8852 7.80669 10.8852 6.16956H9.72933ZM7.92093 7.97796C6.92218 7.97796 6.11253 7.16831 6.11253 6.16956H4.95665C4.95665 7.80669 6.28381 9.13385 7.92093 9.13385V7.97796Z"
                      fill="#101616"
                    />
                  </svg>
                </div>
                <div>Subscribe here</div>
              </div>
              <Link to={"/"}>
                <div className="flex gap-y-20">
                  <div>Learn more</div>
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.93945 11.8229H17.7619M17.7619 11.8229L11.3507 5.41162M17.7619 11.8229L11.3507 18.2341"
                      stroke="#333333"
                      strokeWidth="1.83178"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="sm:w-full md:w-[43%] h-full">
          <Carousel autoplay>
            <div>
              <img src={potato} />
            </div>
            <div>
              <img src={tomato} />
            </div>
            <div>
              <img src={onion} />
            </div>
          </Carousel>
        </div>
      </section>

      <section className="w-full flex flex-col justify-start gap-3">
        <div className="flex flex-col">
          <div className="border-b-[1px] border-gray-200 font-bold text-lg">
            Why SHEGA-FRE?
          </div>
          <div className="mt-3 text-dark-700">
            We provide all the agriculture related materials and also make the
            connection between all the{" "}
          </div>
        </div>
        <div className="flex flex-col lg:flex-row gap-4 w-full">
          <div className="w-full lg:w-2/5">
            <img
              src={tractor}
              width={100}
              height={100}
              alt="tractor"
              className=" rounded-xl shadow-2xl w-full "
            />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 w-full lg:w-3/5">
            <div className="flex flex-col gap-2 rounded-xl shadow-lg ring-1 ring-gray-200 p-4 w-max-[435px]">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.7497 4.66724L28.5533 16.4247L41.5316 18.3217L32.1406 27.4685L34.3569 40.3904L22.7497 34.2863L11.1425 40.3904L13.3587 27.4685L3.96777 18.3217L16.9461 16.4247L22.7497 4.66724Z"
                  stroke="#009602"
                  stroke-width="3.75638"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <h2 className="font-extrabold">Reliable & Trustworthy</h2>
              <h3 className="font-light text-gray-400">
                It has a capacity to orchestrate different agricultural value
                chain actors, Already demonstrated in the horticulture sector,
                We have signed different contract agreements with diverse value
                chain actors, and the platform is secured and updated regularly
              </h3>
            </div>
            <div className="flex flex-col gap-2 rounded-xl shadow-lg ring-1 ring-gray-200 p-4 w-max-[435px]">
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_36_25)">
                  <path
                    d="M29.9257 39.2771V35.5364C29.9257 33.5522 29.1375 31.6493 27.7345 30.2463C26.3315 28.8433 24.4285 28.0551 22.4444 28.0551H9.35197C7.36779 28.0551 5.46487 28.8433 4.06185 30.2463C2.65882 31.6493 1.87061 33.5522 1.87061 35.5364V39.2771"
                    stroke="#009602"
                    stroke-width="3.74068"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.8979 20.5737C20.0297 20.5737 23.3792 17.2242 23.3792 13.0923C23.3792 8.96048 20.0297 5.61096 15.8979 5.61096C11.766 5.61096 8.4165 8.96048 8.4165 13.0923C8.4165 17.2242 11.766 20.5737 15.8979 20.5737Z"
                    stroke="#009602"
                    stroke-width="3.74068"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.7959 20.5737L35.5366 24.3144L43.0179 16.833"
                    stroke="#009602"
                    stroke-width="3.74068"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_36_25">
                    <rect width="44.8882" height="44.8882" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <h2 className="font-extrabold">Professional & Experienced</h2>
              <h3 className="font-light text-gray-400">
                designed and developed by software engineers having multiple
                years of experience in digital agriculture system development
                and understands how agriculture can be digitized. Existing
                agronomists too are the back bone of the agriculture practices.
              </h3>
            </div>
            <div className="flex flex-col gap-2 rounded-xl shadow-lg ring-1 ring-gray-200 p-4 w-max-[435px]">
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M33.6662 3.74072H11.2221C9.15621 3.74072 7.48145 5.41548 7.48145 7.4814V37.4069C7.48145 39.4728 9.15621 41.1475 11.2221 41.1475H33.6662C35.7321 41.1475 37.4069 39.4728 37.4069 37.4069V7.4814C37.4069 5.41548 35.7321 3.74072 33.6662 3.74072Z"
                  stroke="#009602"
                  stroke-width="3.74068"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.4443 33.6661H22.4639"
                  stroke="#009602"
                  stroke-width="3.74068"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <h2 className="font-extrabold">Platform Capability</h2>
              <h3 className="font-light text-gray-400">
                The platform automates the interaction across divers value chain
                actors it is easy for subscription and operation, can operate at
                scale and also easily customizable to accommodate new
                agricultural value chains,
              </h3>
            </div>
            <div className="flex flex-col gap-2 rounded-xl shadow-lg ring-1 ring-gray-200 p-4 w-max-[435px]">
              <svg
                width="46"
                height="45"
                viewBox="0 0 46 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3395 20.5738L20.8209 3.74072C22.309 3.74072 23.7362 4.33188 24.7885 5.38415C25.8407 6.43642 26.4319 7.86361 26.4319 9.35175V16.8331H37.018C37.5602 16.827 38.0973 16.9388 38.592 17.1608C39.0868 17.3829 39.5273 17.7098 39.8831 18.119C40.2389 18.5282 40.5015 19.0099 40.6527 19.5306C40.8039 20.0514 40.8401 20.5988 40.7587 21.1349L38.1776 37.968C38.0424 38.8599 37.5893 39.673 36.9019 40.2573C36.2145 40.8416 35.3391 41.1577 34.4369 41.1475H13.3395M13.3395 20.5738V41.1475M13.3395 20.5738H7.72847C6.73638 20.5738 5.78493 20.9679 5.08341 21.6694C4.3819 22.3709 3.98779 23.3224 3.98779 24.3145V37.4069C3.98779 38.399 4.3819 39.3504 5.08341 40.0519C5.78493 40.7534 6.73638 41.1475 7.72847 41.1475H13.3395"
                  stroke="#009602"
                  stroke-width="3.74068"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <h2 className="font-extrabold">Fresh Farm Products</h2>
              <h3 className="font-light text-gray-400">
                Among the variety of products, the platform is readily available
                to organize:
                <ul className="mt-2 list-disc pl-4">
                  <li>Potato value chain</li>
                  <li>Barley Value Chain</li>
                  <li>Tomato Value Chain, accommodate new value chains.</li>
                </ul>
              </h3>
            </div>
          </div>
        </div>
      </section>

      <section className="hidden md:flex items-center justify-around h-[40px] w-full bg-green-400 mt-[50px]">
        <Link
          to={"/"}
          className="flex justify-center items-center text-white w-[25%] border-r-2 border-[#78A867]"
        >
          <svg
            fill="#fff"
            width="32px"
            height="32px"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#fff"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M21.95 5.005l-3.306-.004c-3.206 0-5.277 2.124-5.277 5.415v2.495H10.05v4.515h3.317l-.004 9.575h4.641l.004-9.575h3.806l-.003-4.514h-3.803v-2.117c0-1.018.241-1.533 1.566-1.533l2.366-.001.01-4.256z"></path>
            </g>
          </svg>
          <span>facebook</span>
        </Link>
        <Link
          to="/"
          className="flex justify-center items-center gap-2 text-white w-[25%] border-r-2 border-[#78A867]"
        >
          <svg
            fill="#ffffff"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 512 512"
            stroke="#ffffff"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g id="7935ec95c421cee6d86eb22ecd12f847">
                {" "}
                <path d="M459.186,151.787c0.203,4.501,0.305,9.023,0.305,13.565 c0,138.542-105.461,298.285-298.274,298.285c-59.209,0-114.322-17.357-160.716-47.104c8.212,0.973,16.546,1.47,25.012,1.47 c49.121,0,94.318-16.759,130.209-44.884c-45.887-0.841-84.596-31.154-97.938-72.804c6.408,1.227,12.968,1.886,19.73,1.886 c9.55,0,18.816-1.287,27.617-3.68c-47.955-9.633-84.1-52.001-84.1-102.795c0-0.446,0-0.882,0.011-1.318 c14.133,7.847,30.294,12.562,47.488,13.109c-28.134-18.796-46.637-50.885-46.637-87.262c0-19.212,5.16-37.218,14.193-52.7 c51.707,63.426,128.941,105.156,216.072,109.536c-1.784-7.675-2.718-15.674-2.718-23.896c0-57.891,46.941-104.832,104.832-104.832 c30.173,0,57.404,12.734,76.525,33.102c23.887-4.694,46.313-13.423,66.569-25.438c-7.827,24.485-24.434,45.025-46.089,58.002 c21.209-2.535,41.426-8.171,60.222-16.505C497.448,118.542,479.666,137.004,459.186,151.787z">
                  {" "}
                </path>{" "}
              </g>{" "}
            </g>
          </svg>
          <span>Twitter</span>
        </Link>
        <Link
          to="/"
          className="flex justify-center items-center gap-2 text-white w-[25%] border-r-2 border-[#78A867]"
        >
          <svg
            width="32px"
            height="32px"
            viewBox="0 -3 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="#ffffff"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fill-rule="evenodd"
              >
                {" "}
                <g
                  id="Dribbble-Light-Preview"
                  transform="translate(-300.000000, -7442.000000)"
                  fill="#ffffff"
                >
                  {" "}
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    {" "}
                    <path
                      d="M251.988432,7291.58588 L251.988432,7285.97425 C253.980638,7286.91168 255.523602,7287.8172 257.348463,7288.79353 C255.843351,7289.62824 253.980638,7290.56468 251.988432,7291.58588 M263.090998,7283.18289 C262.747343,7282.73013 262.161634,7282.37809 261.538073,7282.26141 C259.705243,7281.91336 248.270974,7281.91237 246.439141,7282.26141 C245.939097,7282.35515 245.493839,7282.58153 245.111335,7282.93357 C243.49964,7284.42947 244.004664,7292.45151 244.393145,7293.75096 C244.556505,7294.31342 244.767679,7294.71931 245.033639,7294.98558 C245.376298,7295.33761 245.845463,7295.57995 246.384355,7295.68865 C247.893451,7296.0008 255.668037,7296.17532 261.506198,7295.73552 C262.044094,7295.64178 262.520231,7295.39147 262.895762,7295.02447 C264.385932,7293.53455 264.28433,7285.06174 263.090998,7283.18289"
                      id="youtube-[#168]"
                    >
                      {" "}
                    </path>{" "}
                  </g>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
          <span>YouTube</span>
        </Link>
        <Link
          to="/"
          className="flex justify-center items-center gap-2 text-white w-[25%]"
        >
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fill-rule="evenodd"
              >
                {" "}
                <g
                  id="Dribbble-Light-Preview"
                  transform="translate(-220.000000, -7399.000000)"
                  fill="#fff"
                >
                  {" "}
                  <g id="icons" transform="translate(56.000000, 160.000000)">
                    {" "}
                    <path
                      d="M173.876,7239 C168.399,7239 164,7243.43481 164,7248.95866 C164,7253.05869 166.407,7256.48916 169.893,7258.07936 C169.893,7256.21186 169.88,7256.45286 171.303,7250.38046 C170.521,7248.80236 171.129,7246.19673 172.88,7246.19673 C175.31,7246.19673 173.659,7249.79964 173.378,7251.2174 C173.129,7252.30544 173.959,7253.14238 174.955,7253.14238 C176.864,7253.14238 178.108,7250.71524 178.108,7247.87063 C178.108,7245.69456 176.615,7244.10437 174.042,7244.10437 C169.467,7244.10437 168.307,7249.19966 169.893,7250.79893 C170.292,7251.40294 169.893,7251.43118 169.893,7252.22174 C169.616,7253.05768 167.403,7251.84259 167.403,7248.70757 C167.403,7245.86195 169.727,7242.51518 174.457,7242.51518 C178.191,7242.51518 180.681,7245.27609 180.681,7248.2054 C180.681,7252.13805 178.523,7254.98366 175.37,7254.98366 C174.291,7254.98366 173.295,7254.3978 172.963,7253.72824 C172.36,7256.07371 172.238,7257.26258 171.303,7258.58153 C172.216,7258.83261 173.129,7259 174.125,7259 C179.602,7259 184,7254.56519 184,7249.04235 C183.752,7243.43481 179.353,7239 173.876,7239"
                      id="pinterest-[#180]"
                    >
                      {" "}
                    </path>{" "}
                  </g>{" "}
                </g>{" "}
              </g>{" "}
            </g>
          </svg>
          <span>Pinterest</span>
        </Link>
      </section>

      <section className="w-full flex flex-col gap-2 mt-[50px]">
        <div className="border-b-[1px] border-gray-200 font-bold text-lg">
          Register as a value chain actor
        </div>
        <div className="mt-3 text-dark-700">
          We provide a platform that organizes different agricultural value
          chains and invite you to register here.
        </div>

        <div className="flex flex-row flex-wrap justify-around gap-10">
          <RegisterCard
            href="/subscribe/MICRO-FINANCE"
            title="Banks"
            icon={
              <svg
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.3031 26.2588C23.3931 26.2588 21.5614 27.0175 20.2108 28.3681C18.8603 29.7186 18.1016 31.5504 18.1016 33.4603C18.1016 35.3703 18.8603 37.202 20.2108 38.5526C21.5614 39.9031 23.3931 40.6618 25.3031 40.6618C27.2131 40.6618 29.0448 39.9031 30.3953 38.5526C31.7459 37.202 32.5046 35.3703 32.5046 33.4603C32.5046 31.5504 31.7459 29.7186 30.3953 28.3681C29.0448 27.0175 27.2131 26.2588 25.3031 26.2588ZM22.2167 33.4603C22.2167 32.6418 22.5419 31.8567 23.1207 31.2779C23.6995 30.6991 24.4845 30.3739 25.3031 30.3739C26.1216 30.3739 26.9067 30.6991 27.4855 31.2779C28.0643 31.8567 28.3895 32.6418 28.3895 33.4603C28.3895 34.2789 28.0643 35.0639 27.4855 35.6427C26.9067 36.2215 26.1216 36.5467 25.3031 36.5467C24.4845 36.5467 23.6995 36.2215 23.1207 35.6427C22.5419 35.0639 22.2167 34.2789 22.2167 33.4603Z"
                  fill="#EE8F00"
                />
                <path
                  d="M36.674 11.064L30.1329 1.89337L6.0819 21.107L4.74858 21.0926V21.1132H3.69922V45.8042H46.9084V21.1132H44.929L40.9908 9.59283L36.674 11.064ZM40.5813 21.1132H19.9479L35.316 15.8746L38.4476 14.8726L40.5813 21.1132ZM32.6082 12.4508L16.7443 17.8581L29.3079 7.82126L32.6082 12.4508ZM7.81438 37.9216V28.9917C8.68246 28.6841 9.47095 28.1866 10.1224 27.5356C10.7738 26.8845 11.2717 26.0963 11.5797 25.2284H39.0279C39.3358 26.0966 39.8336 26.8852 40.485 27.5366C41.1364 28.188 41.925 28.6858 42.7932 28.9937V37.9236C41.925 38.2316 41.1364 38.7294 40.485 39.3808C39.8336 40.0322 39.3358 40.8208 39.0279 41.689H11.5839C11.2756 40.8201 10.7772 40.0309 10.1251 39.3791C9.47294 38.7273 8.6835 38.2294 7.81438 37.9216Z"
                  fill="#EE8F00"
                />
              </svg>
            }
          />

          <RegisterCard
            href="/subscribe/MULTI-PURPOSE-COOPERATIVE"
            title="Input Supliers"
            icon={
              <svg
                width="30"
                height="29"
                viewBox="0 0 30 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.94238 23.8567V17.9187H5.31756V21.4815H24.319V7.23046H5.31756V10.7932H2.94238V4.85529H26.6941V23.8567H2.94238ZM14.2245 19.7001L12.5618 17.9781L15.0261 15.5436H2.94238V13.1684H15.0261L12.5618 10.7338L14.2245 9.01184L19.5686 14.356L14.2245 19.7001Z"
                  fill="#EE8F00"
                />
              </svg>
            }
          />

          <RegisterCard
            href="/"
            title="Insurance"
            icon={
              <svg
                width="65"
                height="66"
                viewBox="0 0 65 66"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.361328"
                  y="0.810791"
                  width="64.5451"
                  height="64.5451"
                  rx="32.2726"
                  fill="#FFB800"
                  fill-opacity="0.21"
                />
                <path
                  d="M20.4482 40.1784L25.3639 44.2755C26.0868 44.8774 26.9978 45.2069 27.9384 45.2067H40.8974C41.8226 45.2067 42.5729 44.4565 42.5729 43.5313C42.5729 41.6809 41.0724 40.1784 39.22 40.1784H30.2112M35.9998 20.5679C35.7331 20.5679 35.4773 20.6739 35.2887 20.8625C35.1001 21.0511 34.9942 21.3069 34.9942 21.5736V24.4035H32.1662C31.8995 24.4035 31.6437 24.5095 31.4551 24.6981C31.2665 24.8867 31.1606 25.1425 31.1606 25.4092V28.6776C31.1606 28.9443 31.2665 29.2001 31.4551 29.3887C31.6437 29.5773 31.8995 29.6833 32.1662 29.6833H34.9942V32.5112C34.9942 32.7779 35.1001 33.0337 35.2887 33.2223C35.4773 33.4109 35.7331 33.5169 35.9998 33.5169H39.2683C39.535 33.5169 39.7908 33.4109 39.9794 33.2223C40.168 33.0337 40.2739 32.7779 40.2739 32.5112V29.6833H43.1018C43.3686 29.6833 43.6244 29.5773 43.813 29.3887C44.0016 29.2001 44.1075 28.9443 44.1075 28.6776V25.4092C44.1075 25.1425 44.0016 24.8867 43.813 24.6981C43.6244 24.5095 43.3686 24.4035 43.1018 24.4035H40.2739V21.5716C40.2739 21.3049 40.168 21.0491 39.9794 20.8605C39.7908 20.6719 39.535 20.5659 39.2683 20.5659L35.9998 20.5679Z"
                  stroke="#EE8F00"
                  stroke-width="2.01133"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26.4822 38.1687L27.9907 39.6772C28.1888 39.8753 28.424 40.0324 28.6828 40.1397C28.9417 40.2469 29.2191 40.302 29.4992 40.302C29.7794 40.302 30.0568 40.2469 30.3156 40.1397C30.5744 40.0324 30.8096 39.8753 31.0077 39.6772C31.2058 39.4791 31.363 39.2439 31.4702 38.9851C31.5774 38.7263 31.6326 38.4489 31.6326 38.1687C31.6326 37.8886 31.5774 37.6111 31.4702 37.3523C31.363 37.0935 31.2058 36.8583 31.0077 36.6602L28.6665 34.319C27.9123 33.5646 26.8893 33.1406 25.8225 33.1404H20.4482"
                  stroke="#EE8F00"
                  stroke-width="2.01133"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          />

          <RegisterCard
            href="/subscribe/OFF_TAKERS"
            title="Off Taker"
            icon={
              <svg
                width="65"
                height="66"
                viewBox="0 0 65 66"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.277344"
                  y="0.866943"
                  width="64.6903"
                  height="64.6903"
                  rx="32.3451"
                  fill="#FFB800"
                  fill-opacity="0.21"
                />
                <path
                  d="M32.3435 30.5765C34.9457 30.5765 37.0551 28.467 37.0551 25.8649C37.0551 23.2627 34.9457 21.1532 32.3435 21.1532C29.7413 21.1532 27.6318 23.2627 27.6318 25.8649C27.6318 28.467 29.7413 30.5765 32.3435 30.5765Z"
                  stroke="#EE8F00"
                  stroke-width="2.35583"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.9446 44.7114C42.9446 38.8566 38.1982 34.1102 32.3434 34.1102C26.4886 34.1102 21.7422 38.8566 21.7422 44.7114"
                  stroke="#EE8F00"
                  stroke-width="2.35583"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M32.3431 44.7114L34.699 41.7666L32.3431 34.1102L29.9873 41.7666L32.3431 44.7114Z"
                  stroke="#EE8F00"
                  stroke-width="2.35583"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          />

          {/* Transporter */}
          <RegisterCard
            href="/subscribe/TRANSPORTERS"
            title="Transporter"
            icon={
              <svg
                width="65"
                height="66"
                viewBox="0 0 65 66"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.277344"
                  y="0.866943"
                  width="64.6903"
                  height="64.6903"
                  rx="32.3451"
                  fill="#FFB800"
                  fill-opacity="0.21"
                />
                <path
                  d="M32.3435 30.5765C34.9457 30.5765 37.0551 28.467 37.0551 25.8649C37.0551 23.2627 34.9457 21.1532 32.3435 21.1532C29.7413 21.1532 27.6318 23.2627 27.6318 25.8649C27.6318 28.467 29.7413 30.5765 32.3435 30.5765Z"
                  stroke="#EE8F00"
                  stroke-width="2.35583"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M42.9446 44.7114C42.9446 38.8566 38.1982 34.1102 32.3434 34.1102C26.4886 34.1102 21.7422 38.8566 21.7422 44.7114"
                  stroke="#EE8F00"
                  stroke-width="2.35583"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M32.3431 44.7114L34.699 41.7666L32.3431 34.1102L29.9873 41.7666L32.3431 44.7114Z"
                  stroke="#EE8F00"
                  stroke-width="2.35583"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          />
        </div>
      </section>

      <section className="w-full flex flex-col-reverse justify-between md:flex-row mt-[50px] gap-x-20">
        <div className="flex flex-col gap-4 w-full md:w-1/2">
          <h1 className="font-extrabold text-3xl leading-10">
            Are you an agricultural product processing off taker facing those
            challenges?
          </h1>
          <ul className="list-disc pl-4">
            <li className="mb-2">
              Did you have any control regarding the agricultural input sourcing
              (product quantity, variety and quality)?{" "}
            </li>
            <li className="mb-2">
              Did you face any challenge regarding tracking the production
              lifecycle what you want to collect during harvest time?
            </li>
            <li className="mb-2">
              Did you face a challenge to trace the grower of the product what
              you purchase?
            </li>
            <li className="mb-2">
              Did you face a challenge to have a Agricultural Product contract
              with the grower farmer?
            </li>
            <li className="mb-2">Did you face a cumbersome input sourcing?</li>
            <li className="mb-2">
              Do you face a challenge to trace back farm gate price?
            </li>
            <li className="mb-2">
              Did you face a planning challenge to secure production input for
              future processing?
            </li>
            <li>
              If you want to address all these challenges, you are in the right
              platform. Why do not you register here and start to control input
              source? Or contract our call center 8500 for additional
              information?
            </li>
          </ul>
          <Button
            onClick={() => navigate("/subscribe")}
            type="primary"
            className="w-[200px] text-green-400 font-bold bg-white hover:bg-white"
          >
            Register now {">"}
          </Button>
        </div>
        <img
          src={farmer}
          width={100}
          height={100}
          alt="farmer"
          className=" w-full md:w-1/2"
        />
      </section>
    </div>
  );
}

export default HomePage;
